export default (theme) => ({
  root: {
    overflow: 'visible',
    '& .button-container': {
      '& button': {
        minWidth: 'auto',
        width: theme.spacing(4),
        height: theme.spacing(4),
        margin: -1,
        borderRadius: 0,
        padding: 0,
        '&.num': {
          '&.cur': {
            textDecoration: "underline",
          }
        },
        [theme.breakpoints.down('xs')]: {
          width: theme.spacing(5),
          height: theme.spacing(5),
          fontSize: '1.2em'
        }
      },
      [theme.breakpoints.down('xs')]: {
        display: 'flex',
        justifyContent: 'center',
        paddingTop: theme.spacing(1),
      }
    },
  },
  toolbar: {
    padding: theme.spacing(1),
    minHeight: 0,
    justifyContent: "space-evenly",
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column'
    }
  },
  spacer: {
    display: "none"
  }
});
